<p-dialog appendTo="body" header="SNMP Interfaces" [(visible)]="visible" [modal]="true" 
          [style]="{'width': '1000px'}" [contentStyle]="{'overflow': 'hidden'}"
          [resizable]="false" (onHide)="hide()">

    <div class="row">
        <label class="col-lg-3">Total Interfaces: {{totalInterfaceCount}}</label>
        <span class="col-lg-1"></span>
        <label class="col-lg-3">Selected Interfaces: {{selectedInterfaceCount}}</label>
    </div>

    <p-table [value]="entries" [resizableColumns]="true" dataKey="dataKey"
             [scrollable]="true" scrollHeight="300px"
             [customSort]="true" (sortFunction)="doCustomSort($event)"
             [(selection)]="selectedEntries">

        <ng-template pTemplate="header">
            <tr>
                <th class="uv-table-checkbox">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn pSortableColumn="ifIndex">
                    IF Index
                    <p-sortIcon field="ifIndex"></p-sortIcon>
                </th>
                <th pResizableColumn pSortableColumn="alias">
                    Alias
                    <p-sortIcon field="alias"></p-sortIcon>
                </th>
                <th pResizableColumn pSortableColumn="name">
                    Name
                    <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pResizableColumn pSortableColumn="description">
                    Description
                    <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th pResizableColumn pSortableColumn="adminStatus">
                    Admin Status
                    <p-sortIcon field="adminStatus"></p-sortIcon>
                </th>
                <th pResizableColumn pSortableColumn="operStatus">
                    Oper Status
                    <p-sortIcon field="operStatus"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td class="uv-table-checkbox">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['ifIndex']}}</span>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['alias']}}</span>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['name']}}</span>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['description']}}</span>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['adminStatus']}}</span>
                </td>
                <td>
                    <span class="uv-table-value">{{rowData['operStatus']}}</span>
                </td>
            </tr>
        </ng-template>

    </p-table>

    <p-footer>
        <button type="button" pButton icon="fa fa-check" [disabled]="false"
                (click)="onOkClicked()" label="OK"></button>
        <button type="button" pButton icon="fa fa-times" [disabled]="false"
                (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

</p-dialog>